var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.companyData.length != 0)?_c('div',[(_vm.onDuty != 'open')?_c('closed'):_vm._e(),(_vm.inStore)?_c('orderView'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }